import ApiService from "@/common/api.service";
import {
  FETCH_ISSUES,
  FETCH_ISSUE,
  UPDATE_ISSUE,
  CREATE_ISSUE,
  RESET_ISSUE,
  DELETE_ISSUE,
  UPDATE_ISSUE_STATUS,
  FETCH_ISSUE_STATUS_HISTORY,
  FINNISH_ISSUE
} from "./actions.type";
import {
  FETCH_ISSUE_START,
  SET_ISSUES,
  SET_ISSUE,
  SET_ISSUE_STATUS_HISTORY
} from "./mutations.type";
import {
  CONFIRMED,
  IN_PROGRESS,
  IN_VERIFICATION,
  RESOLVED,
  UNCONFIRMED
} from "@/common/enums/issueStatuses";
import _ from "lodash";

const state = {
  issues: [],
  issuesCount: 1,
  issue: {
    vehicles: []
  },
  issueStatusHistory: [],
  finnishIssue: {},
  isLoading: false
};

const getters = {
  issuesCount: state => state.issuesCount,
  issues: state => state.issues,
  issue: state => state.issue,
  issueStatusHistory: state => state.issueStatusHistory,
  finnishIssue: state => state.finnishIssue,
  issueIsLoading: state => state.isLoading
};

const actions = {
  [FETCH_ISSUES]({ commit }, [filteringCriteria, search, filters]) {
    let parsedFilters = _.clone(filters);
    if (parsedFilters.status) {
      switch (parsedFilters.status) {
        case "active":
          parsedFilters["status:in"] = [
            IN_VERIFICATION,
            CONFIRMED,
            IN_PROGRESS
          ].join(",");
          delete parsedFilters.status;
          break;
        case "resolved":
          parsedFilters["status:in"] = [RESOLVED, UNCONFIRMED].join(",");
          delete parsedFilters.status;
          break;
      }
    }

    commit(FETCH_ISSUE_START);
    return ApiService.filteredCollection(
      "issues",
      filteringCriteria,
      search,
      parsedFilters
    ).then(({ data }) => {
      commit(SET_ISSUES, data);
    });
  },
  [FETCH_ISSUE](context, id) {
    return ApiService.get("issues", id).then(({ data }) => {
      context.commit(SET_ISSUE, data);
      context.commit(SET_ISSUE_STATUS_HISTORY, []);
    });
  },
  [UPDATE_ISSUE](context, payload) {
    return ApiService.put(`issues/${payload.id}`, payload);
  },
  [CREATE_ISSUE](context, payload) {
    return ApiService.post("issues", payload);
  },
  [RESET_ISSUE](context) {
    context.commit(SET_ISSUE, {});
  },
  [DELETE_ISSUE](context, id) {
    return ApiService.delete("issues", id);
  },
  [UPDATE_ISSUE_STATUS](context, payload) {
    return ApiService.put(`issues/${payload.id}/status`, payload);
  },
  [FETCH_ISSUE_STATUS_HISTORY](context, id) {
    context.commit(FETCH_ISSUE_START);
    return ApiService.get(`issues/${id}/status-history`).then(({ data }) => {
      context.commit(SET_ISSUE_STATUS_HISTORY, data);
    });
  },
  [FINNISH_ISSUE](context, [id, payload]) {
    return ApiService.post(`issues/${id}/finnish`, payload);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_ISSUE_START](state) {
    state.isLoading = true;
  },
  [SET_ISSUES](state, data) {
    state.issues = data.items || [];
    state.issuesCount = data.total || 1;
    state.isLoading = false;
  },
  [SET_ISSUE](state, data) {
    state.issue = data;
    state.isLoading = false;
  },
  [SET_ISSUE_STATUS_HISTORY](state, data) {
    state.issueStatusHistory = data;
    state.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
